import { _ as r } from "./index837.mjs";
var a = r, o = a["__core-js_shared__"], s = o;
export {
  s as _
};
